module.exports = __webpack_public_path__ + "static/img/logo.389b5ded.png";